export default __webpack_public_path__ + "static/media/video.2e3665e1.svg";